document.addEventListener('rebuy.init', () => {
  window.customBadges = function(product) {
    if (!product || !window.productBadgesData) {
      return false;
    }
    return window.productBadgesData.find(badge => badge.id === product.metafields.custom.product_card_badge) || false;
  };
});

